import { render, staticRenderFns } from "./myInfosixth.vue?vue&type=template&id=763fd00e&scoped=true"
import script from "./myInfosixth.vue?vue&type=script&lang=js"
export * from "./myInfosixth.vue?vue&type=script&lang=js"
import style0 from "./myInfosixth.vue?vue&type=style&index=0&id=763fd00e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763fd00e",
  null
  
)

export default component.exports